import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { DeviceDefinitionSummaryModel } from "./deviceDefinitionSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class DeviceDefinitionModel implements IWithSummaryModel<DeviceDefinitionSummaryModel> {
  summary: DeviceDefinitionSummaryModel;
  manufacturer: LovValueSummary;
}

